import React, { useContext, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Typography
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { UserContext } from 'src/contexts/userContext';
import { UserType } from 'src/interfaces/UserTypes';
import FileUploadButton from 'src/components/FileUploadButton';
import DocumentList from 'src/components/DocumentList';
import GuidanceResourceList from './GuidanceResourceList';

interface DocumentsTabProps {
  installationId: number;
  // Product of this installation. When set, admin-published guidance files for
  // the product are shown read-only above the installation's own documents.
  product?: number;
}

function DocumentsTab({ installationId, product }: DocumentsTabProps) {
  const { currentUser } = useContext(UserContext);
  const [refreshKey, setRefreshKey] = useState(0);
  const canDelete = currentUser?.userType === UserType.admin;

  return (
    <Container maxWidth="lg" sx={{ mt: 3, mb: 3 }}>
      {product != null && <GuidanceResourceList product={product} />}
      <Card>
        <CardHeader
          title={
            <FormattedMessage
              id="installationDocuments"
              defaultMessage="Installation Documents"
            />
          }
        />
        <Divider />
        <CardContent>
          <DocumentList
            installationId={installationId}
            refreshKey={refreshKey}
            canDelete={canDelete}
          />
          <Box
            sx={{
              mt: 2,
              // Phones: stretch the "Attach Files" control to full width so it is
              // an easy tap target. Desktop (>=md) keeps its natural auto width.
              '& .MuiButton-root': { width: { xs: '100%', md: 'auto' } }
            }}
          >
            <FileUploadButton
              scope={1}
              installationId={installationId}
              onUploaded={() => setRefreshKey((k) => k + 1)}
            />
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
            <FormattedMessage
              id="documentsHint"
              defaultMessage="Accepted formats: JPEG, PNG, GIF, WebP, PDF, MP4, MOV, WebM. Maximum file size: 100 MB."
            />
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
}

export default DocumentsTab;
